import { CustomerTableCellProps } from "./types";
import { mergeClasses, Text } from "@fluentui/react-components";
import { Flex } from "@/components/atoms/flex";
import { useTableStyle } from "@/components/atoms/customTable";
import TooltipWithMount from "@/components/atoms/tooltipWithMount/TooltipWithMount";
import { useMemo } from "react";
import { DirectionArrow } from "@/components/atoms/directionArrow";

export const CustomerTableCell = (props: CustomerTableCellProps) => {
	const tableClasses = useTableStyle();

	const hasBothInfos = useMemo(() => {
		if (props.name && props.contactInformation) {
			return true;
		}
		return false;
	}, [props]);

	const singleProp = useMemo(
		() => (props.name ? props.name : props.contactInformation),
		[props]
	);

	return (
		<Flex>
			{props.displayAvatar && (
				<Flex
					vAlign={"center"}
					className={mergeClasses(
						tableClasses.customAvatar,
						tableClasses.waitingInteractionAvatar,
						props.classesName?.icon
					)}
				>
					{props.icon}
				</Flex>
			)}

			{hasBothInfos && (
				<Flex
					column
					className={
						props.displayAvatar
							? tableClasses.textContainerWithPadding
							: tableClasses.textContainerWithoutPadding
					}
				>
					<Flex>
						<TooltipWithMount
							key={"below"}
							withArrow
							positioning={"below"}
							content={{
								children: props.name ?? "",
								className: tableClasses.tooltip,
							}}
							relationship="label"
						>
							<Text
								className={mergeClasses(
									tableClasses.ellipsis,
									tableClasses.primaryText
								)}
							>
								{props.name}
							</Text>
						</TooltipWithMount>
					</Flex>
					<Flex vAlign="center">
						<DirectionArrow
							direction={props.direction}
							className={tableClasses.directionArrow}
						/>
						<TooltipWithMount
							key={"below"}
							withArrow
							positioning={"below"}
							content={{
								children: props.contactInformation ?? "",
								className: tableClasses.tooltip,
							}}
							relationship="label"
						>
							<Text className={tableClasses.ellipsis}>
								{props.contactInformation}
							</Text>
						</TooltipWithMount>
					</Flex>
				</Flex>
			)}
			{!hasBothInfos && (
				<Flex
					column
					className={
						props.displayAvatar
							? tableClasses.textContainerWithPadding
							: tableClasses.textContainerWithoutPadding
					}
					hAlign="center"
				>
					<Flex>
						<TooltipWithMount
							key={"below"}
							withArrow
							positioning={"below"}
							content={{
								children: singleProp ?? "",
								className: tableClasses.tooltip,
							}}
							relationship="label"
						>
							<Text
								className={mergeClasses(
									tableClasses.ellipsis,
									tableClasses.primaryText
								)}
							>
								{singleProp}
							</Text>
						</TooltipWithMount>
					</Flex>
				</Flex>
			)}
		</Flex>
	);
};
